var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubmittedFilled = function SvgSubmittedFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#submittedFilled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4BAE4F",
    fillRule: "evenodd",
    d: "M48 0C21.525 0 0 21.525 0 48s21.525 48 48 48 48-21.525 48-48S74.475 0 48 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38.756 69.957c-6.131-6.132-12.225-12.32-18.375-18.45a1.766 1.766 0 0 1 0-2.475l7.069-7.07a1.766 1.766 0 0 1 2.475 0L40.031 52.07 66.02 26.063a1.79 1.79 0 0 1 2.493 0L75.6 33.15c.694.694.694 1.8 0 2.475L41.231 69.957a1.73 1.73 0 0 1-2.475 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "submittedFilled_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h96v96H0z"
  })))));
};
export default SvgSubmittedFilled;